import styled from '@emotion/styled/macro';
import { CheckboxItem as DefaultCheckboxItem } from '@chronos/components/Checkbox/styled';
import TextareaAutosize from 'react-textarea-autosize';
import {
  DateTimePicker,
  DatePickerTrigger,
  DateSide,
  Input as DateInput,
} from '@chronos/components/DateTimePicker/styled';
import { Trigger } from '@chronos/components/Popup/styled';
import ReactInputMask from 'react-input-mask';
import ReactSelect from 'react-select';

const DateInputWidth = '100px';

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #afafaf;
  }

  ${DateTimePicker} {
    ${Trigger} {
      width: ${DateInputWidth};
    }
    ${DatePickerTrigger} {
      width: ${DateInputWidth};
      background-color: transparent;
      padding: 0;
      box-shadow: none;

      ${DateSide} {
        width: ${DateInputWidth};
        ${DateInput} {
          text-align: center;
          border-radius: 5px;
          height: 40px;
        }
      }
    }
  }
`;

export const InputLabel = styled.div`
  // color: #6b778c;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3333333333333333;
  padding-bottom: 5px;
  padding-top: ${({ paddingTop = "5" }) => `${paddingTop}px`};
`;

export const InputRow = styled.div`
  display: flex;
`;

export const Input = styled('input', {
  shouldForwardProp: (prop) => !['isInvalid'].includes(prop),
})`
  display: flex;
  flex-shrink: 2;
  width: 100%;
  margin: 5px 0;

  border: 0;
  padding: 8px 12px;

  -webkit-appearance: none;
  border: none;
  border-radius: 3px;
  box-sizing: border-box;
  line-height: 20px;
  outline: none;
  transition-duration: 85ms;
  transition-property: background-color, border-color, box-shadow;
  transition-timing-function: ease;

  background-color: ${({ theme }) => theme.input.background};
  box-shadow: ${({ isInvalid, theme }) =>
    isInvalid ? theme.input.boxShadowError : theme.input.boxShadow};
  &:hover {
    outline: none;
    box-shadow: ${({ isInvalid, theme }) =>
      isInvalid ? theme.input.boxShadowError : theme.input.boxShadowHovered};
  }
  &:focus {
    outline: none;
    box-shadow: ${({ isInvalid, theme }) =>
      isInvalid ? theme.input.boxShadowError : theme.input.boxShadowFocused};
  }
`;

export const Error = styled.div`
  color: red;
`;

export const RequiredIndicator = styled.span`
  padding-left: 2px;
  color: rgb(255, 86, 48);
`;

export const InputExample = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  flex-shrink: 1;
  width: 100%;
  margin: 10px;
`;

// -------------------------------

export const CheckboxItem = styled(DefaultCheckboxItem)`
  /* margin-top: 8px; */
`;

export const WorklogComment = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 120px;
`;

export const Textarea = styled(TextareaAutosize, {
  shouldForwardProp: (prop) => !['invalidMessage', 'isInvalid'].includes(prop),
})`
  width: 100%;

  display: inline;
  margin: 4px 0 12px;

  background-color: ${({ theme }) => theme.input.background};
  box-shadow: ${({ isInvalid, theme }) =>
    isInvalid ? theme.input.boxShadowError : theme.input.boxShadow};
  border: 0;

  -webkit-appearance: none;
  border: none;
  border-radius: 3px;
  box-sizing: border-box;
  line-height: 20px;
  outline: none;
  padding: 8px 12px;
  transition-duration: 85ms;
  transition-property: background-color, border-color, box-shadow;
  transition-timing-function: ease;

  &:hover {
    outline: none;
    box-shadow: ${({ isInvalid, theme }) =>
      isInvalid ? theme.input.boxShadowError : theme.input.boxShadowHovered};
  }
  &:focus {
    outline: none;
    box-shadow: ${({ isInvalid, theme }) =>
      isInvalid ? theme.input.boxShadowError : theme.input.boxShadowFocused};
  }
`;

export const DateTimePickerWrapper = styled.div`
  display: flex;
  gap: 10px;

  /* flex-flow: row nowrap; */
  /* align-items: center; */
`;

export const TimeInput = styled(ReactInputMask)`
  width: 60px;
  text-align: center;
  /* border: none; */
  font-weight: 300;
  border-radius: 4px;
  border: none;

  // background-color: #f4f5f7;
  background-color: ${({ theme }) => theme.input.background};
  box-shadow: ${({ isInvalid, theme }) =>
    isInvalid ? theme.input.boxShadowError : theme.input.boxShadow};

  &:hover {
    outline: none;
    box-shadow: ${({ isInvalid, theme }) =>
      isInvalid ? theme.input.boxShadowError : theme.input.boxShadowHovered};
  }
  &:focus {
    outline: none;
    box-shadow: ${({ isInvalid, theme }) =>
      isInvalid ? theme.input.boxShadowError : theme.input.boxShadowFocused};
  }
`;

export const EstimateText = styled.div`
  padding-bottom: 5px;
`;

export const EstimateTime = styled.span`
  background-color: rgb(223, 225, 230);
  border-radius: 4px;
  display: inline-block;
  font-size: 12px;
  color: rgb(66, 82, 110);
  font-weight: 700;
  padding: 5px;
`;

export const Select = styled(ReactSelect)`
  position: ${(props) => props.position};
  .rs__control {
    background-color: #fafbfc;
    &--is-focused {
      outline: none;
      box-shadow: ${({ theme }) => theme.input.boxShadowFocused};
    }
    &--is-disabled {
      opacity: 40%;
    }
  }
  .rs__menu {
    .rs__option--is-selected {
      background-color: rgb(2, 121, 192) !important;
    }
    .rs__option--is-focused {
      background-color: rgb(2, 121, 192, 0.2);
    }
  }
`;

export const ModalFooter = styled.footer`
  //padding: 20px;
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  gap: 8px;
`;
